import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"24\" height=\"24\" y=\".5\" fill=\"url(#a)\" rx=\"12\"></rect><path fill=\"#422290\" d=\"M14.194 7.297q.095.062.136.172a.37.37 0 0 1 .008.227l-1.146 4.023h2.115q.095.001.175.056c.052.037.092.09.117.151a.37.37 0 0 1-.06.372l-5.091 5.844a.299.299 0 0 1-.392.062.34.34 0 0 1-.137-.173.37.37 0 0 1-.007-.226l1.146-4.024H8.943a.3.3 0 0 1-.175-.056.34.34 0 0 1-.117-.151.37.37 0 0 1 .06-.372l5.091-5.844a.298.298 0 0 1 .391-.062zM9.25 5.5l.605 1.645 1.645.605-1.645.605L9.25 10l-.605-1.645L7 7.75l1.645-.605zM15.438 15.625l.453 1.234 1.234.453-1.234.454L15.438 19l-.454-1.234-1.234-.453 1.234-.454z\"></path><defs><linearGradient id=\"a\" x1=\"24\" x2=\"0\" y1=\"12.5\" y2=\"12.5\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#EDD2FF\"></stop><stop offset=\"1\" stop-color=\"#DAD8FC\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }